// import React from "react";
// import { ReactP5Wrapper } from "react-p5-wrapper"; // im using "react-p5-wrapper": "^3.0.2",

// function grid(p){
//   const GRID_COLOR = [200, 200, 200, 80]; // Light gray with low alpha
//   p.push();
//   p.stroke(...GRID_COLOR);
//   p.strokeWeight(1);
//   let step = 40; // Size of grid squares

//   // Draw grid much larger than canvas so it doesn't "run out" during camera movement
//   let gridSize = 2000;
//   for (let x = -gridSize; x <= gridSize; x += step) {
//       p.line(x, -gridSize, x, gridSize);
//   }
//   for (let y = -gridSize; y <= gridSize; y += step) {
//       p.line(-gridSize, y, gridSize, y);
//   }
//   p.pop();
// }

// const Checkboxtrulymatter = ({ p5ref, wt, ht, scale, fs, bgcolor }) => {


//   const sketch = (p) => {
//     // --- Color definitions ---
//     const BLACK = [51, 51, 51];
//     const PINK = [235, 93, 123];
//     const BLUE = [93, 105, 235];
//     const BEIGE = [255, 254, 246];

//     let firstText = 'A soulmate isn’t about checking every box';
//     let secondText = 'but the few that truly matter.';
//     let latoFont = 'Lato'; // Font name reference
//     let feelWidths = [];
//     let doWidths = [];
//     let spaceKerning = 4.75;

//     // --- Animation variables ---
//     let checkboxes = [];
//     let totalBoxes = 5;
//     let boxSize = 30;
//     let spacing = 60;
//     let animIndex = 0;
//     let checkInterval = 30;
//     let expanding = false;

//     // Character-specific extra spacing
//     const letter_extra_space = {
//       'a': 1.05, 'b': 1, 'c': 1, 'd': 1, 'e': 1.5, 'f': 0, 'g': 1, 'h': 1, 'i': 1, 'j': 1,
//       'k': 1, 'l': 0.1, 'm': 1, 'n': 1, 'o': 1, 'p': 1, 'q': 1, 'r': -0.2, 's': 2, 't': 0,
//       'u': 1, 'v': 0, 'w': 1, 'x': 1, 'y': 1, 'z': 1,
//       'A': 1, 'B': 1, 'C': 1, 'D': 1, 'E': 1, 'F': 1, 'G': 1, 'H': 1, 'I': 1, 'J': 1,
//       'K': 1, 'L': 0.5, 'M': 1, 'N': 1, 'O': 1, 'P': 1, 'Q': 1, 'R': 1, 'S': 1, 'T': 1,
//       'U': 1, 'V': 1, 'W': 1, 'X': 1, 'Y': 1, 'Z': 1
//     };

//     // --- Helpers ---
//     function loadGoogleFont() {
//       const link = document.createElement('link');
//       link.href = 'https://fonts.googleapis.com/css2?family=Lato&display=swap';
//       link.rel = 'stylesheet';
//       document.head.appendChild(link);
//     }

//     function setupCheckboxes() {
//       let startY = -((totalBoxes - 1) / 2) * spacing;
//       for (let i = 0; i < totalBoxes; i++) {
//         checkboxes.push({
//           x: 0,
//           y: startY + i * spacing,
//           size: boxSize,
//           checked: false,
//           crossed: false,
//           alpha: 255
//         });
//       }
//     }

//     // --- Setup ---
//     p.setup = () => {
//       loadGoogleFont();
//       // p.createCanvas returns the renderer, used for stream capture
//       let c = p.createCanvas(wt, ht);
//       p.rectMode(p.CENTER);
//       p.ellipseMode(p.CENTER);
//       p.textAlign(p.LEFT, p.CENTER);
//       p.textSize(fs);

//       // Set font (css takes a moment to load, but p5 attempts to use name)
//       p.textFont(latoFont);

//       // Precompute character widths
//       for (let i = 0; i < firstText.length; i++) {
//         let charWidth = p.textWidth(firstText[i]);
//         let extra = (firstText[i] === ' ' ? spaceKerning : (letter_extra_space[firstText[i]] || 0));
//         feelWidths[i] = charWidth + extra;
//       }
//       for (let i = 0; i < secondText.length; i++) {
//         let charWidth = p.textWidth(secondText[i]);
//         let extra = (secondText[i] === ' ' ? spaceKerning : (letter_extra_space[secondText[i]] || 0));
//         doWidths[i] = charWidth + extra;
//       }

//       // Initialize boxes
//       setupCheckboxes();


//     };

//     // --- Main Content Logic ---
//     const maincontent = () => {
//       p.push();
//       p.translate(p.width / 2, p.height / 2.25);

//       // Animate checking one by one
//       if (!expanding && animIndex < totalBoxes) {
//         if (p.frameCount % checkInterval === 0) {
//           if (checkboxes[animIndex]) {
//             checkboxes[animIndex].checked = true;

//             // Only the third box (index 2) is checked, others are crossed
//             if (animIndex === 2) {
//               checkboxes[animIndex].crossed = false;
//             } else {
//               checkboxes[animIndex].crossed = true;
//             }
//             animIndex++;
//           }
//         }
//       }

//       // Start expansion after all checked
//       if (animIndex >= totalBoxes) expanding = true;

//       // Animate expansion and fade/move other boxes
//       if (expanding) {
//         for (let i = 0; i < checkboxes.length; i++) {
//           let cb = checkboxes[i];
//           if (i === 2) {
//             cb.size = p.lerp(cb.size, 100, 0.05); // special box grows
//           } else {
//             let dir = i < 2 ? -1 : 1;
//             cb.y += dir * 2;
//             cb.alpha = p.lerp(cb.alpha, 0, 0.05);
//           }
//         }
//       }

//       // Draw checkboxes
//       for (let i = 0; i < checkboxes.length; i++) {
//         let cb = checkboxes[i];
//         p.push();
//         p.noFill();
//         p.stroke(BLACK[0], BLACK[1], BLACK[2], cb.alpha);
//         p.strokeWeight(2);
//         p.rect(cb.x, cb.y, cb.size, cb.size);

//         // Draw check or cross
//         if (cb.checked) {
//           p.strokeWeight(4);
//           p.stroke(
//             cb.crossed ? BLUE[0] : PINK[0],
//             cb.crossed ? BLUE[1] : PINK[1],
//             cb.crossed ? BLUE[2] : PINK[2],
//             cb.alpha
//           );

//           let offset = cb.size / 4;

//           if (cb.crossed) {
//             // Draw X
//             p.line(cb.x - offset, cb.y - offset, cb.x + offset, cb.y + offset);
//             p.line(cb.x - offset, cb.y + offset, cb.x + offset, cb.y - offset);
//           } else {
//             // Draw check
//             // To make the checkmark look nice centered
//             p.line(cb.x - offset, cb.y, cb.x, cb.y + offset);
//             p.line(cb.x, cb.y + offset, cb.x + offset, cb.y - offset);
//           }
//         }
//         p.pop();
//       }




//       p.pop();
//     };

//     // --- Text Logic ---
//     const statictext = () => {
//       p.push();
//       p.textSize(fs);
//       p.textFont(latoFont);
//       p.textAlign(p.LEFT, p.CENTER);

//       let centerX = p.width / 2;
//       let firstY = p.height - 120;
//       let secondY = firstY + 24;

//       let firstWidth = feelWidths.reduce((sum, w) => sum + w, 0);
//       let secondWidth = doWidths.reduce((sum, w) => sum + w, 0);

//       let firstStartX = centerX - firstWidth / 2;
//       let secondStartX = centerX - secondWidth / 2;

//       p.fill(BLACK[0], BLACK[1], BLACK[2]);

//       let x = firstStartX;
//       for (let i = 0; i < firstText.length; i++) {
//         p.text(firstText[i], x, firstY);
//         x += feelWidths[i];
//       }

//       x = secondStartX;
//       for (let i = 0; i < secondText.length; i++) {
//         p.text(secondText[i], x, secondY);
//         x += doWidths[i];
//       }
//       p.pop();
//     };

//     // --- Draw Loop ---
//     p.draw = () => {
//       p.background(BEIGE);
//       grid(p);
//       maincontent();
//       statictext();
//     };
//   };

//   return <div style={{ backgroundColor: bgcolor }}>
//     <div ref={p5ref} style={{ transform: `scale(${scale})` }}>
//       <ReactP5Wrapper sketch={sketch} />
//     </div>
//   </div>

// };

// export default Checkboxtrulymatter

import React from "react";
import { ReactP5Wrapper } from "react-p5-wrapper";

function grid(p) {
  const GRID_COLOR = [200, 200, 200, 80];
  p.push();
  p.stroke(...GRID_COLOR);
  p.strokeWeight(1);
  let step = 40;
  let gridSize = 2000;
  for (let x = -gridSize; x <= gridSize; x += step) {
    p.line(x, -gridSize, x, gridSize);
  }
  for (let y = -gridSize; y <= gridSize; y += step) {
    p.line(-gridSize, y, gridSize, y);
  }
  p.pop();
}

const Checkboxtrulymatter = ({ p5ref, wt, ht, scale, fs, bgcolor }) => {
  const sketch = (p) => {
    // --- CONSTANTS ---
    const DRAW_SPEED = 0.05; // Adjust this: Lower is slower, Higher is faster
    const BLACK = [51, 51, 51];
    const PINK = [235, 93, 123];
    const BLUE = [93, 105, 235];
    const BEIGE = [255, 254, 246];

    let firstText = "A soulmate isn’t about checking every box";
    let secondText = "but the few that truly matter.";
    let latoFont = "Lato";
    let feelWidths = [];
    let doWidths = [];
    let spaceKerning = 4.75;

    let checkboxes = [];
    let gridDimension = 3;
    let totalBoxes = 9;
    let boxSize = 40;
    let spacingY = 80;
    let spacingX = 80;
    let animIndex = 0;
    let expanding = false;

    const letter_extra_space = {
      'a': 1.05, 'e': 1.5, 'l': 0.1, 'r': -0.2, 's': 2, 'L': 0.5
    };

    function loadGoogleFont() {
      const link = document.createElement("link");
      link.href = "https://fonts.googleapis.com/css2?family=Lato&display=swap";
      link.rel = "stylesheet";
      document.head.appendChild(link);
    }

    function setupCheckboxes() {
      let startX = -((gridDimension - 1) / 2) * spacingX;
      let startY = -((gridDimension - 1) / 2) * spacingY;

      for (let row = 0; row < gridDimension; row++) {
        for (let col = 0; col < gridDimension; col++) {
          checkboxes.push({
            x: startX + col * spacingX,
            y: startY + row * spacingY,
            col: col,
            row: row,
            size: boxSize,
            checked: false,
            crossed: false,
            alpha: 255,
            progress: 0 
          });
        }
      }
    }

    p.setup = () => {
      loadGoogleFont();
      p.createCanvas(wt, ht);
      p.rectMode(p.CENTER);
      p.ellipseMode(p.CENTER);
      p.textAlign(p.LEFT, p.CENTER);
      p.textSize(fs);
      p.textFont(latoFont);

      for (let i = 0; i < firstText.length; i++) {
        let charWidth = p.textWidth(firstText[i]);
        let extra = firstText[i] === " " ? spaceKerning : (letter_extra_space[firstText[i]] || 0);
        feelWidths[i] = charWidth + extra;
      }
      for (let i = 0; i < secondText.length; i++) {
        let charWidth = p.textWidth(secondText[i]);
        let extra = secondText[i] === " " ? spaceKerning : (letter_extra_space[secondText[i]] || 0);
        doWidths[i] = charWidth + extra;
      }

      setupCheckboxes();
    };

    const maincontent = () => {
      p.push();
      p.translate(p.width / 2, p.height / 2.25);

      // --- SEQUENTIAL LOGIC ---
      if (!expanding && animIndex < totalBoxes) {
        let cb = checkboxes[animIndex];
        cb.checked = true;
        cb.crossed = !(cb.col === 1 && cb.row === 1);

        // Increment progress of the current box
        cb.progress += DRAW_SPEED;

        // Only move to next box if this one is finished (progress >= 1)
        if (cb.progress >= 1) {
          cb.progress = 1; // Clamp it
          animIndex++;
        }
      }

      if (animIndex >= totalBoxes && !expanding) {
          expanding = true;
      }

      if (expanding) {
        for (let cb of checkboxes) {
          if (cb.col === 1 && cb.row === 1) {
            cb.size = p.lerp(cb.size, 120, 0.05);
          } else {
            let moveDirX = cb.col - 1;
            let moveDirY = cb.row - 1;
            cb.x += moveDirX * 3;
            cb.y += moveDirY * 3;
            cb.alpha = p.lerp(cb.alpha, 0, 0.07);
          }
        }
      }

      // --- DRAWING LOOP ---
      for (let cb of checkboxes) {
        if (cb.alpha <= 0.1) continue;

        p.push();
        p.noFill();
        p.stroke(BLACK[0], BLACK[1], BLACK[2], cb.alpha);
        p.strokeWeight(2);
        p.rect(cb.x, cb.y, cb.size, cb.size);

        if (cb.checked) {
          p.strokeWeight(4);
          p.stroke(
            cb.crossed ? BLUE[0] : PINK[0],
            cb.crossed ? BLUE[1] : PINK[1],
            cb.crossed ? BLUE[2] : PINK[2],
            cb.alpha
          );

          let offset = cb.size / 4;
          let prg = cb.progress;

          if (cb.crossed) {
            // Sequential Cross: Draw first line (0-0.5) then second (0.5-1.0)
            let line1 = p.constrain(p.map(prg, 0, 0.5, 0, 1), 0, 1);
            p.line(cb.x - offset, cb.y - offset, p.lerp(cb.x - offset, cb.x + offset, line1), p.lerp(cb.y - offset, cb.y + offset, line1));
            
            if (prg > 0.5) {
              let line2 = p.constrain(p.map(prg, 0.5, 1, 0, 1), 0, 1);
              p.line(cb.x + offset, cb.y - offset, p.lerp(cb.x + offset, cb.x - offset, line2), p.lerp(cb.y - offset, cb.y + offset, line2));
            }
          } else {
            // Sequential Tick: Draw short stem (0-0.3) then long stem (0.3-1.0)
            let stem1 = p.constrain(p.map(prg, 0, 0.3, 0, 1), 0, 1);
            p.line(cb.x - offset, cb.y, p.lerp(cb.x - offset, cb.x, stem1), p.lerp(cb.y, cb.y + offset, stem1));

            if (prg > 0.3) {
              let stem2 = p.constrain(p.map(prg, 0.3, 1, 0, 1), 0, 1);
              p.line(cb.x, cb.y + offset, p.lerp(cb.x, cb.x + offset, stem2), p.lerp(cb.y + offset, cb.y - offset, stem2));
            }
          }
        }
        p.pop();
      }
      p.pop();
    };

    const statictext = () => {
      p.push();
      p.textSize(fs);
      p.textFont(latoFont);
      p.textAlign(p.LEFT, p.CENTER);
      let centerX = p.width / 2;
      let firstY = p.height - 120;
      let secondY = firstY + 24;
      let firstWidth = feelWidths.reduce((sum, w) => sum + w, 0);
      let secondWidth = doWidths.reduce((sum, w) => sum + w, 0);
      let firstStartX = centerX - firstWidth / 2;
      let secondStartX = centerX - secondWidth / 2;
      p.fill(BLACK[0], BLACK[1], BLACK[2]);
      let x = firstStartX;
      for (let i = 0; i < firstText.length; i++) {
        p.text(firstText[i], x, firstY);
        x += feelWidths[i];
      }
      x = secondStartX;
      for (let i = 0; i < secondText.length; i++) {
        p.text(secondText[i], x, secondY);
        x += doWidths[i];
      }
      p.pop();
    };

    p.draw = () => {
      p.background(BEIGE);
      grid(p);
      maincontent();
      statictext();
    };
  };

  return (
    <div style={{ backgroundColor: bgcolor }}>
      <div ref={p5ref} style={{ transform: `scale(${scale})` }}>
        <ReactP5Wrapper sketch={sketch} />
      </div>
    </div>
  );
};

export default Checkboxtrulymatter;